import { render, staticRenderFns } from "./AddPermissionModal.vue?vue&type=template&id=88a97bf4&scoped=true"
import script from "./AddPermissionModal.vue?vue&type=script&lang=ts"
export * from "./AddPermissionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a97bf4",
  null
  
)

export default component.exports